import 'bootstrap';
import './scss/app.scss';
import './scss/main.scss';
import './scss/main-responsive.scss';

import Swiper from 'swiper';
var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin($);

import * as Vibrant from 'node-vibrant';

require('jquery.easing');

//Navigation
$(function () {
    const $navigation = $('.navbar-menu');
    const $body = $('body');
    const $trigger = $('[data-toggle="navbar-menu"]');

    let a, b;

    function toggleMenu(e) {
        e.preventDefault();

        if (!$body.hasClass('menu-is-open')) {
            clearTimeout(b);

            $body.addClass('menu-is-open');
            $navigation.css('display', 'block');

            a = setTimeout(function () {
                $navigation.addClass('menu-open');
            }, 50);
        } else {
            $body.removeClass('menu-is-open');
            $navigation.removeClass('menu-open');

            b = setTimeout(function () {
                $navigation.css('display', '');
            }, 400);
        }
    }

    $trigger.bind('click', toggleMenu);
});

//Load single div backgrounds
$(function () {
    var image = document.querySelectorAll('img[data-bg="true"], [data-bg="true"]');

    for (var i = 0; i < image.length; i++) {
        (function (n) {
            var img = new Image();

            img.onload = imageFound;
            img.onerror = imageNotFound;
            img.src = image[n].src;

            function imageFound() {
                image[n].parentNode.style.backgroundImage = 'url(' + img.src + ')';

                if ($(image[n]).parent().is('.bg')) {
                    $(image[n]).parent().css({
                        opacity: '1'
                    });
                }
            }

            function imageNotFound() {
                image[n].parentNode.style.backgroundColor = '#eaeaea';
            }
        }(i));
    }
});

//Load section backgrounds
$(function () {
    var section = document.querySelectorAll('div[data-section-bg], section[data-section-bg], [data-section-bg]');

    for (var i = 0; i < section.length; i++) {
        (function (n) {
            var img = new Image();
            var sectionBG = document.createElement('div');

            sectionBG.classList.add('section-bg');

            img.onload = imageFound;
            img.onerror = imageNotFound;
            img.src = section[n].getAttribute('data-section-bg');

            function imageFound() {
                section[n].append(sectionBG);
                sectionBG.style.backgroundImage = 'url(' + img.src + ')';
            }

            function imageNotFound() {
                sectionBG.style.backgroundColor = '#eaeaea';
            }
        }(i));
    }
});

//Masonry
$(function () {
    var grid = document.querySelector('.gallery-masonry');

    if ($(grid).length > 0) {
        var msnry = new Masonry(grid, {
            columnWidth: '.gallery-masonry-sizer',
            itemSelector: '.gallery-masonry-item',
            percentPosition: true,
        });

        imagesLoaded(grid).on('progress', function () {
            msnry.layout();
        });
    }
});

//Smooth Scroll
$(function () {
    // Select all links with hashes
    $('[data-scroll="smooth"]').click(function (event) {
        // Figure out element to scroll to
        var target = $(this.hash);

        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
            scrollTop: target.offset().top
        }, 1000, 'easeInOutQuart', function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
                return false;
            } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
            }
        });
    });
});

//Swiper - Homepage Slider
$(function() {
    var swiperWrapper = $('.swiper-home-wrapper');

    var interleaveOffset = 1,
        counter = $('.swiper-slide-navigation-count'),
        productImage = $('.swiper-slide-product-image'),
        productMiscImage = $('.swiper-slide-product-misc-image');

    if (swiperWrapper.length > 0) {
        var swiper = new Swiper('.swiper-home', {
            init: false,
            speed: 1000,
            slidesPerView: 1,
            noSwipingClass: 'swiper-home',
            watchSlidesProgress: true,
            navigation: {
                prevEl: '.swiper-home-wrapper .swiper-btn-prev',
                nextEl: '.swiper-home-wrapper .swiper-btn-next',
            },
            on: {
                progress: function () {
                    var swiper = this;
                    for (var i = 0; i < swiper.slides.length; i++) {
                        var slideProgress = swiper.slides[i].progress;
                        var innerOffset = swiper.width * interleaveOffset;
                        var innerTranslate = slideProgress * innerOffset;
                        swiper.slides[i].querySelector(".swiper-slide-transition").style.transform = "translate3d(" + innerTranslate + "px, 0, 0)";
                        swiper.slides[i].querySelector(".swiper-slide-transition > .swiper-slide-thumb").style.transform = "scale(" + (0.1 + (1 + (slideProgress * 0.1))) + ")";
                    }
                },
                touchStart: function () {
                    var swiper = this;
                    for (var i = 0; i < swiper.slides.length; i++) {
                        swiper.slides[i].style.transition = "";
                    }
                },
                setTransition: function (speed) {
                    var swiper = this;
                    for (var i = 0; i < swiper.slides.length; i++) {
                        swiper.slides[i].style.transition = speed + "ms";
                        swiper.slides[i].querySelector(".swiper-slide-transition").style.transition = speed + "ms";
                        swiper.slides[i].querySelector(".swiper-slide-transition").style.transitionTimingFunction = "ease";
                        swiper.slides[i].querySelector(".swiper-slide-transition > .swiper-slide-thumb").style.transitionTimingFunction = "cubic-bezier(0.86, 0, 0.07, 1)";
                        swiper.slides[i].querySelector(".swiper-slide-transition > .swiper-slide-thumb").style.transition = speed + "ms";
                    }
                },
                slideChange: function() {
                    var activeSlideIndex = (swiper.activeIndex + 1);
                    var slidesLength = swiper.slides.length;
                    var productImageSrc = swiper.slides[swiper.activeIndex].getAttribute('data-product-image');
                    var productMiscImageSrc = swiper.slides[swiper.activeIndex].getAttribute('data-product-misc-image');

                    productImage.css({
                        opacity: 0,
                    });

                    productMiscImage.css({
                        opacity: 0,
                    });

                    setTimeout(function() {
                        productImage.css({
                            backgroundImage: 'url(' + productImageSrc + ')',
                        });
                        productMiscImage.css({
                            backgroundImage: 'url(' + productMiscImageSrc + ')',
                        });
                        setTimeout(function() {
                            productImage.css({
                                opacity: 1,
                            });
                            productMiscImage.css({
                                opacity: 1,
                            });
                        }, 50);
                    }, 500);

                    counter.html('0' + activeSlideIndex + '<span>/0' + slidesLength + '</span>');
                },
            }
        });

        swiper.on('init', function() {
            var activeSlideIndex = (swiper.activeIndex + 1);
            var slidesLength = swiper.slides.length;
            var productImageSrc = swiper.slides[swiper.activeIndex].getAttribute('data-product-image');
            var productMiscImageSrc = swiper.slides[swiper.activeIndex].getAttribute('data-product-misc-image');

            productImage.css({
                backgroundImage: 'url(' + productImageSrc + ')',
            });

            productMiscImage.css({
                backgroundImage: 'url(' + productMiscImageSrc + ')',
            });

            counter.html('0' + activeSlideIndex + '<span>/0' + slidesLength + '</span>');
        });
        swiper.init();
    }
});

//Swiper - Products Carousel
$(function() {
    var swiperWrapper = $('.swiper-products-wrapper');

    if (swiperWrapper.length > 0) {
        var swiper = new Swiper('.swiper-products', {
            slidesPerView: 'auto',
            spaceBetween: 30,
        });
    }
});

//Increment/Decrement
$(function () {
    $(".product-quantity-more").append('<div class="inc button">+</div><div class="dec button">-</div>');

    $(".button").on("click", function () {

        let $button = $(this);
        let oldValue = $button.parent().find("input").val();

        let newVal = 1;

        if ($button.hasClass('inc')) {
            newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 1) {
                newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }

        $button.parent().find("input").val(newVal);
    });

    $('[data-quantity="more"]').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $(this).text('Reset');
            $('.product-quantity').css({display: 'none'});
            $('.product-quantity-more').css({display: 'flex'});
        } else {
            $(this).removeClass('active');
            $(this).text('Want More?');
            $('.product-quantity').css({display: ''});
            $('.product-quantity-more').css({display: ''});
        }
    });
});

//Vibrant.js
$(function() {
    var element = document.querySelectorAll('.collection-card-cover img');

    for (var i = 0; i < element.length; i++) {
        (function(n) {
            var elementSrc = element[n].src;

            var v = new Vibrant(elementSrc);

            v.getPalette().then((palette) => {
                $(element[n]).closest('.collection-card').find('.collection-card-thumb').css({
                    backgroundColor: 'rgb(' + palette.LightMuted._rgb[0] + ', ' + palette.LightMuted._rgb[1] + ', ' + palette.LightMuted._rgb[0] + ')'
                });
                $(element[n]).closest('.collection-card').find('.collection-card-content').css({
                    backgroundColor: 'rgba(' + palette.LightMuted._rgb[0] + ', ' + palette.LightMuted._rgb[1] + ', ' + palette.LightMuted._rgb[0] + ', 0.2)'
                });
            });
        }(i));
    }
});

//Custom dropdown
$(function () {
    let $trigger = $('div[data-toggle="select-box"]'),
        $option = $('.select-box-custom-option');

    function toggleSelect() {
        var $this = $(this);

        $('.select-box-custom').not($this.closest('.select-box-custom')).removeClass('active');
        $('.select-box-custom').not($this.closest('.select-box-custom')).closest('.col-lg-12').css({
            zIndex: '',
        });

        if (!$this.closest('.select-box-custom').hasClass('active')) {
            $this.closest('.select-box-custom').addClass('active');
            $this.closest('.col-lg-12').css({
                zIndex: '99',
            });
        } else {
            $this.closest('.select-box-custom').removeClass('active');
            $this.closest('.col-lg-12').css({
                zIndex: '',
            });
        }
    }

    function selectOption(e) {
        e.preventDefault();
        let $this = $(this);

        if ($this.closest('.select-box-custom').find('.select-box-custom-selected').length) {
            $this.closest('.select-box-custom').find('.select-box-custom-selected').text($this.text());
        }

        //Update <select> value
        $this.closest('.select-box-custom').next().val($this.closest('.select-box-custom').find('.select-box-custom-dropdown').find('li').eq($this.index()).text());

        //Remove "active' class from custom select
        $('.select-box-custom').removeClass('active');
    }

    $(document).on('mouseup', function (e) {
        let container = $('.select-box-custom');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('active');
        }
    });

    $(document).on('keydown', function (e) {
        let keyCode = e.keyCode || e.which;

        if (keyCode == 9) {
            if ($('.select-box-custom').hasClass('active')) {
                $('.select-box-custom').removeClass('active');
            }
        }
    });

    $(document).on('click', 'div[data-toggle="select-box"]', toggleSelect);
    $(document).on('click', '.select-box-custom-option', selectOption);
    $trigger.click(toggleSelect);
    $option.click(selectOption);
});

//Replace old select with custom dropdown
$(function () {
    var $field = $('select[class*="gfield_select"], select, .select');

    $field.each(function () {
        var $this = $(this);

        var placeholder = $this.data("placeholder") === undefined ? $this.find("option:first-child").text() : $this.data("placeholder");

        var $template = $('<div class="select-box-custom">' +
            '    <div class="select-box-custom-selected" data-toggle="select-box">' + placeholder + '</div>' +
            '    <ul class="select-box-custom-dropdown">' +
            '    </ul>' +
            '</div>');

        $template.insertBefore($this);

        $this.find('option').each(function () {
            var that = $(this);
            var $thisOption;

            if (that.attr('data-show-more') === 'true') {
                $thisOption = '<li data-show-more="true" data-target="' + that.data("target") + '" class="select-box-custom-option">' + that.text() + '</li>';
            } else {
                $thisOption = '<li class="select-box-custom-option">' + that.text() + '</li>';
            }

            $this.prev().find('.select-box-custom-dropdown').append($thisOption);
        });
    });

    var trigger = document.querySelectorAll('.select-box-custom-option'),
        expandable = $('.expandable-info');

    var a;

    for (var i = 0; i < trigger.length; i++) {
        trigger[i].onclick = function () {
            var target = document.querySelector(this.getAttribute('data-target'));

            if (this.getAttribute('data-show-more') !== null) {
                if ($(this.parentNode).is($(this).siblings().parent())) {
                    expandable.css({
                        display: ''
                    });
                }

                target.style.display = 'block';
            } else {
                if ($(this.parentNode).is($(this).siblings().parent())) {
                    expandable.css({
                        display: ''
                    });
                }
            }
        }
    }
});